/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_Dedup_TitleInputs */



/**
* | output |
* | --- |
* | "Possible existing members" |
*
* @param {Create_Dedup_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const create_dedup_title = /** @type {((inputs?: Create_Dedup_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_Dedup_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Membres existants possibles")
	if (locale === "es") return /** @type {LocalizedString} */ ("Posibles miembros existentes")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Possíveis membros existentes")
	if (locale === "it") return /** @type {LocalizedString} */ ("Possibili membri esistenti")
	return /** @type {LocalizedString} */ ("Possible existing members")
});